import React from 'react';
import Link from '@waglabs/link';
import Image from '@waglabs/image';
import appStoreSvg from './assets/app-store.svg';
import playStoreSvg from './assets/play-store.svg';
import { Distribution, URL, } from './constants';
const DistributionPlatform = Object.freeze({
    [Distribution.AppStore]: {
        iconUrl: appStoreSvg,
        url: URL.AppStore
    },
    [Distribution.PlayStore]: {
        iconUrl: playStoreSvg,
        url: URL.PlayStore,
    },
    [Distribution.AppStorePremium]: {
        iconUrl: appStoreSvg,
        url: URL.AppStorePremium,
    },
    [Distribution.PlayStorePremium]: {
        iconUrl: playStoreSvg,
        url: URL.AppStorePremium,
    }
});
export const AppDownloadButton = ({ distribution, ...rest }) => {
    const distributionPlatform = DistributionPlatform[distribution];
    return (React.createElement(Link, Object.assign({ target: "_blank", href: distributionPlatform.url }, rest),
        React.createElement(Image, { src: distributionPlatform.iconUrl, alt: "distribution-platform-icon-img", width: 1, hover: true })));
};
